import React, { useEffect } from 'react';
import { Route, Routes } from 'routing';
import { isAdminPortal } from 'utils';
import { Spin, ExternalRedirect } from 'library';
import { local } from 'services';
import { useSelector } from 'react-redux';
import PrivacyRoute from './privacy';

const AdministrationApp = React.lazy(() => import('./administration'));
const TermsRoute = React.lazy(() => import('./terms'));
const LinincidentApp = React.lazy(() => import('./lin/incident'));
const LinLinApp = React.lazy(() => import('./lin/lin'));
const LinIncidentReportApp = React.lazy(() => import('./lin/incidentreport'));
const DocumentsRoute = React.lazy(() => import('./documents'));

const linkToNewAdmin = `https://admin.${import.meta.env.VITE_DOMAIN}`;

const App = () => {
    const { isApiVersionUpdated } = useSelector(state => state.layout);

    useEffect(() => {
        const lastApiVersion = local.apiVersion();
        if (isApiVersionUpdated && isApiVersionUpdated !== lastApiVersion) {
            // eslint-disable-next-line no-console
            console.log('New Version Detected:', isApiVersionUpdated);
            local.apiVersion(isApiVersionUpdated);
            // hardReload();
        }
    }, [isApiVersionUpdated]);

    if (isAdminPortal) {
        return <AdministrationApp />;
    }

    function RedirectToNewAdmin() {
        window.location.replace(linkToNewAdmin);
    }

    return (
        <React.Suspense fallback={<Spin className="center" />}>
            <Routes>
                <Route path="/admin/*" element={<RedirectToNewAdmin />} />
                <Route path="/incident/*" element={<LinincidentApp />} />
                <Route path="/lin/*" element={<LinLinApp />} />
                <Route path="/incidentreport/*" element={<LinIncidentReportApp />} />
                <Route path="/documents/:title/:id" element={<DocumentsRoute />} />
                <Route path="/documents/:title" element={<DocumentsRoute />} />
                <Route path="/privacy" element={<PrivacyRoute />} />
                <Route path="/terms" element={<TermsRoute />} />
                <Route
                    path="*"
                    element={<ExternalRedirect url="https://www.companynurse.com/" />}
                />
            </Routes>
        </React.Suspense>
    );
};

export default App;
